import * as React from 'react';

class ArrowDownSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 17 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon arrow-down-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M16.53 1.1498C16.419 1.07953 16.2953 1.0318 16.1659 1.00935C16.0365 0.986897 15.9039 0.990156 15.7758 1.01894C15.6476 1.04773 15.5264 1.10148 15.419 1.17712C15.3117 1.25277 15.2202 1.34882 15.15 1.4598C13.414 4.19254 11.3485 6.70138 8.99999 8.9298C6.64306 6.70755 4.57061 4.20179 2.82999 1.4698C2.6881 1.24569 2.46299 1.08713 2.20419 1.02899C1.94539 0.970857 1.6741 1.01791 1.44999 1.1598C1.22588 1.30169 1.06732 1.5268 1.00919 1.7856C0.951049 2.0444 0.9981 2.31569 1.13999 2.5398C3.00113 5.47449 5.22539 8.16241 7.75999 10.5398C8.09845 10.854 8.54318 11.0286 9.00499 11.0286C9.4668 11.0286 9.91153 10.854 10.25 10.5398C12.7686 8.15819 14.9791 5.47062 16.83 2.5398C16.9023 2.42906 16.9519 2.30508 16.976 2.17503C17 2.04498 16.998 1.91146 16.9701 1.78218C16.9422 1.65291 16.889 1.53045 16.8134 1.4219C16.7379 1.31335 16.6415 1.22087 16.53 1.1498Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default ArrowDownSvg;
